import { RouterProvider } from 'react-router'

import { VersionUpdateNotice } from '@/shared/versioning/VersionUpdateNotice'

import { AppProviders } from './providers/AppProviders'
import { router } from './router'

/**
 * Raíz de la aplicación.
 *
 * Deliberadamente diminuta: solo conecta los proveedores con el router. Toda
 * la lógica vive en las features. Si algún día este archivo empieza a crecer,
 * es señal de que algo se está poniendo en el lugar equivocado.
 */
export function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
      <VersionUpdateNotice />
    </AppProviders>
  )
}
